import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';


@Component({ 
  selector: 'app-provider',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.scss']
})
export class ProvidersComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  isButtonDisabled:boolean
    
  constructor( private adminViewServices:AdminViewService) {
    super();
 
  }

 
  ngOnInit(): void {
    super.ngOnInit()
    this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }


  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
